import script from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"
export * from "./mensajeregalos_ingles.vue?vue&type=script&lang=js"

import "./mensajeregalos_ingles.vue?vue&type=style&index=0&id=05ffd4b6&scoped=true&lang=css"
/* custom blocks */
import block0 from "./mensajeregalos_ingles.vue?vue&type=custom&index=0&blockType=p&class=firma"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ffd4b6"]])

export default __exports__